import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_CHANNEL_FILTER = 'UPDATE_CHANNEL_FILTER' as const;

export const updateChannelFilter = (channel: string[]) => ({ data: { channel }, type: UPDATE_CHANNEL_FILTER });

export type UpdateChannelFilterResponseAction = DataAction<typeof UPDATE_CHANNEL_FILTER, { channel: string[] }>;
